import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { AdminUser } from '@hrlabs/shared-types';
import { deleteAdminUser, listAdminUsers } from '../../lib/functions';
import { useAuth } from '../../lib/auth';
import { useToast } from '../../components/Toast';

export function UserList() {
  const { user } = useAuth();
  const { notify } = useToast();
  const [rows, setRows] = useState<AdminUser[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await listAdminUsers();
      setRows(res.data.users);
    } catch (err) {
      notify('danger', (err as Error).message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    void load();
  }, []);

  const remove = async (uid: string) => {
    if (!confirm('Delete this user?')) return;
    try {
      await deleteAdminUser({ uid });
      notify('success', 'User deleted.');
      void load();
    } catch (err) {
      notify('danger', (err as Error).message);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">Users</h3>
        <Link to="/users/new" className="btn btn-success btn-sm">
          New user
        </Link>
      </div>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Role</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.uid}>
                <td>{u.email}</td>
                <td>{u.displayName ?? '—'}</td>
                <td>
                  <span className={`badge bg-${u.role === 'admin' ? 'success' : 'secondary'}`}>
                    {u.role}
                  </span>
                </td>
                <td className="text-end">
                  <Link to={`/users/${u.uid}`} className="btn btn-sm btn-outline-secondary me-2">
                    Edit role
                  </Link>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    disabled={u.uid === user?.uid}
                    onClick={() => remove(u.uid)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
